import React, { ReactNode, createContext, useContext, useState } from 'react';
import { Contract } from '../components/Contracts/ContractsDropdown';

type Contracts = Contract[];
type FetchContractsContextType = {
  contracts: Contracts;
  setContracts: React.Dispatch<React.SetStateAction<Contracts>>;
  filteredContracts: Contracts;
  setFilteredContracts: React.Dispatch<React.SetStateAction<Contracts>>;
};

const ContractsContext = createContext<FetchContractsContextType | undefined>(undefined);

export const useContractsContext = () => {
  const context = useContext(ContractsContext);

  if (context === undefined) {
    throw new Error('useContractsContext must be used with a ContractsContext');
  }

  return context;
};

export const ContractsContextProvider = ({ children }: { children: ReactNode }) => {
  const [contracts, setContracts] = useState<Contracts>([]);
  const [filteredContracts, setFilteredContracts] = useState<Contracts>([]);

  const value = {
    contracts,
    setContracts,
    filteredContracts,
    setFilteredContracts
  };

  return <ContractsContext.Provider value={value}>{children}</ContractsContext.Provider>;
};
